export default __webpack_public_path__ + "static/media/add.d5cd014c.svg";